import { render, staticRenderFns } from "./ghVideo.vue?vue&type=template&id=5030ebe5&scoped=true&"
import script from "./ghVideo.vue?vue&type=script&lang=js&"
export * from "./ghVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5030ebe5",
  null
  
)

export default component.exports